import { render, staticRenderFns } from "./EventTypeSetting.vue?vue&type=template&id=74f91883"
import script from "./EventTypeSetting.vue?vue&type=script&lang=js"
export * from "./EventTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports